import { Button, IconName } from '@optimus-web/core';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AddBillDialog } from '../BillNameDialog/AddBillDialog';

interface Props {
    accountId: string;
}

export const NewBillButton = ({ accountId }: Props) => {
    const [{ onClose, active }, toggleDialog] = useDialog();

    return (
        <>
            <AddBillDialog active={active} onClose={onClose} accountId={accountId} />
            <Button variant="ghost" icon={IconName.Add} onClick={toggleDialog} type="submit">
                <LocalizedText textKey={TextKey.AddBill} />
            </Button>
        </>
    );
};
